import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';

@Component({
  selector: 'app-delete-confirm',
  templateUrl: './delete-confirm.component.html',
  styleUrls: ['./delete-confirm.component.css']
})
export class DeleteConfirmComponent implements OnInit {
  // 抛出事件
  @Output() callback = new EventEmitter();
  // modal对象
  @ViewChild('modal') modal: SwModalframeComponent;
  // 输入参数 
  @Input() param: any;
  constructor(
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) { }

  ngOnInit() {
  }

  // 删除
  delete(){
    this.modal.toggle();
    // 删除标记关联资源
    if(this.param.name == "relatedResourceDelete"){
      this.kmsService.deleteRelatedFileById(this.param.ids).subscribe(
        data => {
          if(data.code == '200'){
            this.box.success('删除成功！');
            this.callback.emit(true);
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }
    // 删除标记关联实体
    if(this.param.name == "relatedInstanceDelete"){
      this.kmsService.deleteMarkShipById(this.param.ids).subscribe(
        data => {
          if(data.code == '200'){
            this.box.success('删除成功！');
            this.callback.emit(true);
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }
  }
}
